import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DataPagePresenterService } from '../../../../../services/presenter/data-page-presenter.service';

@Component({
  selector: 'app-section-why-choose-us',
  standalone: true,
  templateUrl: './section-why-choose-us.component.html',
  styleUrls: ['./section-why-choose-us.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionWhyChooseUsComponent {
  private readonly dataPresenter = inject(DataPagePresenterService);
  protected readonly sectionData = computed(
    () => this.dataPresenter.data.sections[4].card as any[]
  );
}
